module.exports = __webpack_public_path__ + "static/media/airtable-logo.2c711b57.png";